import styled from 'styled-components';
import { SmallSectionHeader } from 'components/Typography';

export const BodyContainer = styled.div`
  background-color: #fff !important;
  min-height: 93vh;
`;
export const AbsoluteGrid = styled.div`
  top: 100px;
  background-color: #fff !important;
`;
export const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  line-height: 27px !important;
  text-align: justify !important;
  margin-top: 30px !important;
  margin-bottom: 20px !important;
`;
